import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Col, Container, Row } from 'react-bootstrap';
import { FaDelicious } from 'react-icons/fa6'
import mayvin from '../components/reusable/mayvin.png';
import yellowBubble from '../assets/yellow-bubble.png';
import orangeBubble from '../assets/orange-bubble.png';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../App';
import { FaTools } from 'react-icons/fa';

export default function About() {

  const navigate = useNavigate();
  const { windowWidth, isAuthenticated } = useAppContext();
  const isSquished = windowWidth < 900;

  return (
    <div className='d-flex justify-content-center p-4 graph-paper-bkgd' style={{
      minHeight: '100vh',
    }}>
      <Helmet>
        <title>About Crossworthy</title>
        <meta name='description' content='Learn about Crossworthy: create, share, and play your own professional-level crosswords for free.' />
      </Helmet>


      <Container style={{ marginTop: isSquished ? '50px' : '150px', maxWidth: '1000px', height: '100%' }}>

        <Row className='mb-3'>
          <h1 className='balanced-text text-center w-100'>About Crossworthy, a free online crossword maker</h1>
        </Row>

        <Row>
          <p>
            Crossworthy is a <span className='teal-3 fw-bold fs-5 zoomable'>free, independent website</span> where you can make, share, and play professional-quality crosswords.
            We've built Crossworthy to be helpful, beginner-friendly, powerful, and available to anyone with a browser.
          </p>
          <p>
            Since 2020, our goal has been to make crossword creation simple and accessible, especially to new constructors without special software.
            Get automatic <span className='purple-3 fw-bold fs-5 zoomable'>fill suggestions</span> while building your grid, share and collaborate <span className='purple-3 fw-bold fs-5 zoomable'>real-time</span> just like Google Docs (no more PDF attachments!),
            generate professional crosswords <span className='purple-3 fw-bold fs-5 zoomable'>fully online</span>, even publish whole <span className='purple-3 fw-bold fs-5 zoomable'>collections</span> of puzzles that your friends can subscribe to.
            Crossworthy is also a fully-featured solving platform: grab a link to play your puzzles online, or solve them together in collaborative group sessions.
          </p>
          <p>
            Crossworthy is built and maintained independently, and we're always adding features by request! Drop us a line at <a href='mailto:hello@crossworthy.net'>hello@crossworthy.net</a>; we love hearing from fellow puzzle enthusiasts.
          </p>
        </Row>

        <Row className='mt-3 d-flex gap-4 justify-content-center mb-5'>
          <a
            className='d-flex justify-content-center purple-2-bkgd p-2 text-center mb-auto zoomable clickable'
            style={{ borderRadius: 30, width: 280, fontSize: 20, color: 'black', textDecoration: 'none' }}
            href='/construct'
            onClick={e => {
              e.preventDefault();
              navigate(isAuthenticated ? '/construct/f' : '/construct/scratch');
            }}
          ><FaTools className='my-auto' /><span className='ms-3'>Make a crossword</span></a>

          <a
            className='d-flex justify-content-center teal-2-bkgd p-2 text-center mb-auto zoomable clickable'
            style={{ borderRadius: 30, width: 280, fontSize: 20, color: 'black', textDecoration: 'none' }}
            href='/play'
            onClick={e => {
              e.preventDefault();
              navigate('/collections/crossworthy');
            }}
          ><FaDelicious className='my-auto' /><span className='ms-3'>Solve one of ours</span></a>
        </Row>

        {isSquished && <Row className='d-flex'>
          <img className='w-50 mx-auto' src={mayvin} alt='May and Kevin' />
        </Row>}

        <Row className='d-flex justify-content-center align-items-center mb-5' style={{ marginTop: isSquished ? '15px' : '100px' }}>
          <Col className={isSquished ? '' : 'text-end'} xs={isSquished ? 6 : 4}>
            <strong>Kevin</strong> is a hobbyist web developer who first created Crossworthy to show off May's puzzles.
            By day, he works in R&D at a biotech company.
          </Col>

          {!isSquished && <Col xs={4}>
            <img
              className='zoomable clickable'
              src={yellowBubble}
              alt='crossworthy-in-new-york-times'
              width='200px'
              style={{ position: 'absolute', marginTop: '-40px', marginLeft: '96px', rotate: '2deg' }}
              onClick={() => window.open('https://www.nytimes.com/2022/03/24/crosswords/all-in-the-game-of-love.html', '_blank')}
            />
            <img src={mayvin} alt='May and Kevin' width='100%' />
            <img
              className='zoomable clickable'
              src={orangeBubble}
              alt='give-feedback'
              width='200px'
              style={{ marginTop: '-210px', marginLeft: '10px' }}
              onClick={() => navigate('/feedback')}
            />
          </Col>}

          <Col className={isSquished ? '' : 'text-start'} xs={isSquished ? 6 : 4}>
            <strong>May</strong> is a longtime cruciverbalist who loves putting pop culture references in her crosswords.
            By day, she works in communications.
          </Col>
        </Row>
      
      </Container>
    </div>
  );
}